import { UrlConstants } from "../url.constants";
export class ApiScheduledReminderConstants {
    static URL = UrlConstants.API_V2 + "ScheduledReminder";
    static UpdateScheduledReminder = "UpdateScheduledReminder";
}
